module.exports = __webpack_public_path__ + "static/fonts/342F4F_F_0.c91c700.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_F_0.woff
// module id = 113
// module chunks = 3